import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFiefAuth } from '@fief/fief/react';
import { Spin } from 'antd';

const Callback: React.FC = () => {
    const fiefAuth = useFiefAuth();
    const navigate = useNavigate();

    useEffect(() => {
        async function handleCallback() {
            console.log('Callback mounted');

            const codeVerifier = sessionStorage.getItem('fief-codeverifier');
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);

            const code = urlParams.get('code');
            const state = urlParams.get('state');
            const redirectURI = `${window.location.origin}/callback`;

            if (!code) {
                console.error('No code found in callback URL!');
                navigate('/');
                return;
            }

            try {
                if (codeVerifier) {
                    // console.log('Found code_verifier. Normal login flow.');
                    await fiefAuth.authCallback(redirectURI);
                } else {
                    console.error('Missing code_verifier. Redirecting to login.');
                    navigate('/');
                    return;
                }

                // After successful login, redirect
                let path = '/';
                if (state) {
                    try {
                        const u = new URL(state);
                        path = u.pathname + u.search;
                    } catch (e) {
                        console.warn('Invalid state URL. Defaulting to /');
                    }
                }

                console.log('Redirecting to:', path);
                navigate(path);
            } catch (err) {
                console.error('Callback error:', err);
                navigate('/');
            }
        }

        handleCallback();
    }, [fiefAuth, navigate]);

    return (
        <div
            style={{
                display: 'flex',
                height: '100vh',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Spin size="large" />
        </div>
    );
};

export default Callback;
